module.exports = __webpack_public_path__ + "static/media/FIU_Honors.0bb34196.svg";